import { css } from "@microsoft/fast-element";
import { getToken } from "../design-tokens";

// TODO: Should these be tokens too? Should there be a version of these with units?

/**
 * A formula to retrieve the control height.
 * Use this as the value of any CSS property that
 * accepts a pixel size.
 */
export const heightNumber = css.partial`(${getToken('space-base-height-units')} + ${getToken('space-density')}) * ${getToken('space-design-unit')}`;

/**
 * A formula to retrieve the padding for certain controls.
 */
export const paddingNumber = css.partial`(${heightNumber} / 2)`;

export const spacingNumber = css.partial`(${getToken('space-design-unit')} * 5)`;

export const breakpointQuerySmall = css.partial`screen and (min-width: ${getToken('space-breakpoint-small')}px)`;
export const breakpointQueryMedium = css.partial`screen and (min-width: ${getToken('space-breakpoint-medium')}px)`;
export const breakpointQueryLarge = css.partial`screen and (min-width: ${getToken('space-breakpoint-large')}px)`;
export const breakpointQueryExtraLarge = css.partial`screen and (min-width: ${getToken('space-breakpoint-extra-large')}px)`;
